import { BehaviorSubject, map, Observable, takeUntil } from "rxjs"

export type SubjectBalancer<T, SubjectType> = {

  subject: BehaviorSubject<SubjectType>,

  setter: (value: T) => any

  getter: (value: SubjectType) => T

}


export const balanceBehaviorSubjects = <T extends any>(params: {
  until: Observable<any>,
  subjectBalancers: (BehaviorSubject<T> | SubjectBalancer<T, any>)[]
}
) => {

  const { subjectBalancers, until } = params;

  const behaviorSubjects = subjectBalancers.filter((subjectOrBalancer) => subjectOrBalancer instanceof BehaviorSubject) as unknown as BehaviorSubject<T>[];
  const balancers = subjectBalancers.filter((subjectOrBalancer) => !(subjectOrBalancer instanceof BehaviorSubject)) as unknown as SubjectBalancer<T, any>[];

  const subjectSubscribe = (emittedValue: T, subject: BehaviorSubject<T>) => {

    const currentValue = subject.value;

    if (currentValue !== emittedValue) {
      subject.next(emittedValue);
      return;
    }
  }

  const balancerSubscribe = (emittedValue: T, balancer: SubjectBalancer<T, any>) => {
    const currentValue = balancer.getter(balancer.subject.value);

    if (currentValue !== emittedValue) {
      balancer.setter(emittedValue);
      return;
    }
  }


  const subscriber = (emittedValue: T) => {

    balancers.forEach((balancerSubscriber) => balancerSubscribe(emittedValue, balancerSubscriber))
    behaviorSubjects.forEach((subject) => subjectSubscribe(emittedValue, subject))

  }

  balancers.forEach((balancer) =>

    balancer.subject.pipe(
      takeUntil(until),
      map((value) => balancer.getter(value))
    )
      .subscribe((emittedValue) => subscriber(emittedValue))
  )


  behaviorSubjects.forEach((behaviorSubject) =>
    behaviorSubject.pipe(
      takeUntil(until)
    )
      .subscribe((emittedValue) => subscriber(emittedValue)))



}

